import React, { useState } from 'react';
import GenericPage from './GenericPage';
import { SubmitButton } from '../components/Buttons';
import Report from '../components/Report';
import LabsForm from '../forms/LabsForm';
import Modal from '../components/Modal';

const LabsPage = () => {

    const [showLabsFormModal, setShowLabFormModal] = useState(false);
    const [labDataModal, setLabDataModal] = useState(null);
    const [formTitle, setFormTitle] = useState(null);

    const displayLabsFormModal = (labData, formTitle) => {
        setLabDataModal(labData);
        setFormTitle(formTitle)
        setShowLabFormModal(true);
    }

    const labsData = [
        {
            'Laboratorio':'Laboratorio 1',
            'País':'Uruaguay',
            'Contacto': 'contacto',
            'Teléfono': '1231231231',
            'Correo electrónico': 'lab1@lab1.com',
            'Estado': 'Activo',
        },
        {
            'Laboratorio':'Laboratorio 2',
            'País':'Uruaguay',
            'Contacto': 'contacto',
            'Teléfono': '1231231231',
            'Correo electrónico': 'lab2@lab2.com',
            'Estado': 'Activo',
        },
        {
            'Laboratorio':'Laboratorio 3',
            'País':'Uruaguay',
            'Contacto': 'contacto',
            'Teléfono': '1231231231',
            'Correo electrónico': 'lab3@lab3.com',
            'Estado': 'Inactivo',
        },
        
    ];
    return (
        <>
            <GenericPage active='Laboratorios'>
                <div className="report-header">
                    <div className="report-title">
                        <h1>Laboratorios</h1>
                    </div>
                    <div className="report-button">
                        <SubmitButton
                            text="Nuevo"
                            onClickButton={() => displayLabsFormModal(null, "Crear")}
                        />
                    </div>
                </div>
            <Report data={labsData} edit={true} onEditClick={displayLabsFormModal} />
            </GenericPage>
            {showLabsFormModal && (
                <Modal onClickCloseBtn={() => setShowLabFormModal(false)}>
                    <LabsForm data={labDataModal} formTitle={formTitle} />
                </Modal>
            )}
        </>
    );
}

export default LabsPage;
